/**
 * PageLoader Component
 * 
 * Loading fallback for Suspense boundaries when lazy-loading routes
 * Provides consistent loading UI across the application
 */

import React from 'react';
import { Loader2 } from 'lucide-react';

const PageLoader: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="w-8 h-8 animate-spin text-brand-primary" />
        <p className="text-gray-600 text-sm">Chargement...</p>
      </div>
    </div>
  );
};

export default PageLoader;
